import {Component, Injector, model, NgZone, OnInit} from '@angular/core';
import { ServiceTaskModel, ServiceTaskService} from "../../../services/servicetask.service";
import {DialogBaseComponent} from "../../admin-panel/base-admin-panel/dialog-base/dialog-base.component";
import { ConverterService } from "../../../services/converter.service";

@Component({
    selector: 'app-service-dialog-base',
    templateUrl: './service-dialog-base.component.html',
    styleUrls: ['./service-dialog-base.component.css'],
    standalone: false
})
export class ServiceDialogBaseComponent extends DialogBaseComponent<ServiceTaskModel>
{
  private service: ServiceTaskService;
  private converterService: ConverterService;
  private ngZone: NgZone;

  constructor(protected injector: Injector) {
    super(injector);
    this.converterService = injector.get(ConverterService);
    this.service = injector.get(ServiceTaskService);
    this.ngZone = injector.get(NgZone);

  }

  public override open(model: any, type: { new(): ServiceTaskModel } = undefined) {
    super.open(model, type);
    this.updateFromJs(model);
  }

  public updateFromJs(data: any) {
    this.ngZone.run(() => {
      this.model = data;
    });
  }

  public submit()
  {
    this.service.update(this.model)
      .subscribe((res) => {
          this.onCreated.emit();
          this.close();
          super.submit();
        });
  }
  public convertTimePeriod(value: number)
  {
    this.model.TimePeriod = value * 86400000;
  }
  public convertOdometr(value: number)
  {
    this.model.Odometr = this.converterService.ParseKMeters(value);
  }
  public convertOdometrPeriod(value: number)
  {
    this.model.OdometrPeriod = this.converterService.ParseKMeters(value);
  }
  public convertEngineTime(value: number)
  {
    this.model.WorkTime = value * 3600000;
  }
  public convertEngineTimePeriod(value: number)
  {
    this.model.WorkTimePeriod = value * 3600000;
  }
}
